import React from 'react'

export default ({onClick, href, children, target}) =>
    <a
        href={href}
        onClick={onClick}
        className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
        target={target}
    >{children}</a>